__turbopack_context__.v({
  "actions": "_8JCELq_actions",
  "container": "_8JCELq_container",
  "emptyMessage": "_8JCELq_emptyMessage",
  "isEditMode": "_8JCELq_isEditMode",
  "list": "_8JCELq_list",
});
